import { makeStyles } from "@material-ui/styles";

const configurationStyles = makeStyles((theme) => ({
	section: {
		padding: ({ preview }) => !preview && theme.spacing(0, 4, 4, 4),
		width: "100%"
	},
	sectionLabel: {
		textTransform: "capitalize",
		padding: theme.spacing(2, 0)
	},
	// The only thing beside the heading now is its info icon, which belongs
	// next to the title it describes. space-between lived here to push the
	// field presets to the far right; with those gone it stranded the icon
	// against the opposite edge of the screen.
	sectionHeader: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		flexWrap: "wrap"
	},
	sectionRow: {
		margin: theme.spacing(0)
	},
	rowBreak: {
		flexBasis: "100%",
		height: 0
	},
	sectionDivider: {
		marginBottom: theme.spacing(4)
	},
	actionContainer: {
		width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		overflowX: "auto",
		gap: "5px"
	},
	primaryActionContainer: {
		display: "flex",
		alignItems: "center",
		gap: "5px",
		// Keeps Save/Cancel pinned right when the secondary actions
		// (Restore defaults / ruleset) are hidden, e.g. mid-game.
		marginLeft: "auto"
	},
	autoComplete: {
		"& .MuiAutocomplete-inputRoot": { paddingRight: "15px !important" }
	},
	// Fieldset drawn like a MUI v4 outlined input (border color/radius of
	// OutlinedInput's NotchedOutline, same 56px height as the sibling
	// fields) so boolean switches read as one form control among the rest.
	// MUI draws an outlined text field's border 5px ABOVE its 56px input box
	// (NotchedOutline: top -5px), so a boxed control that should line up with
	// the text fields beside it starts 5px higher and is 61px tall.
	switchField: {
		boxSizing: "border-box",
		position: "relative",
		width: "100%",
		height: 61,
		marginTop: -5,
		marginRight: 0,
		marginBottom: 0,
		marginLeft: 0,
		padding: theme.spacing(0, 1.75),
		border: `1px solid ${
			theme.palette.type === "dark"
				? "rgba(255, 255, 255, 0.23)"
				: "rgba(0, 0, 0, 0.23)"
		}`,
		borderRadius: theme.shape.borderRadius
	},
	// Legend sits in the border notch like a shrunk outlined-input label:
	// caption size, secondary color, ~8px from the border start (padding-left
	// is 14px, so pull back 6px). The 11px line box matches MUI's
	// NotchedOutline legend so it doesn't push the content down.
	switchFieldLabel: {
		padding: theme.spacing(0, 0.5),
		marginLeft: -6,
		color: theme.palette.text.secondary,
		fontSize: theme.typography.caption.fontSize,
		height: 11,
		lineHeight: "11px"
	},
	// Center the switch in the 56px box independently of the legend's flow
	// (the legend straddles the top border and would offset static content).
	switchFieldControl: {
		position: "absolute",
		// Centred on the 56px input box the border is drawn around, not on
		// the 61px border box itself.
		top: "calc(50% + 2.5px)",
		left: theme.spacing(1),
		transform: "translateY(-50%)"
	},
	// The same outlined box as the switch fields (same 5px offset and 61px
	// height), but laid out rather than positioned: a radio group is two
	// labelled controls that need the box to size them. Configuration gives a
	// radio group a grid cell wide enough for both options on one line at every
	// breakpoint, so the box stays level with the text fields beside it; the
	// minimum height and wrapping below are the fallback if a caller ever puts
	// one in a narrower cell, in which case the box grows rather than
	// overprinting its legend.
	radioField: {
		boxSizing: "border-box",
		display: "flex",
		alignItems: "center",
		width: "100%",
		minHeight: 61,
		marginTop: -5,
		marginRight: 0,
		marginBottom: 0,
		marginLeft: 0,
		// Tighter than the text fields' 14px so two options fit a half-row
		// cell on a small tablet; the legend keeps the notch alignment.
		padding: "9px 8px 4px",
		border: `1px solid ${
			theme.palette.type === "dark"
				? "rgba(255, 255, 255, 0.23)"
				: "rgba(0, 0, 0, 0.23)"
		}`,
		borderRadius: theme.shape.borderRadius
	},
	radioFieldControl: {
		flexWrap: "wrap"
	},
	// Compact enough for two options to share one line in a quarter-width
	// column on very wide screens, and a label never breaks mid-phrase: it
	// either fits or the whole option wraps.
	radioFieldOption: {
		marginLeft: -6,
		marginRight: theme.spacing(1),
		"& .MuiFormControlLabel-label": {
			fontSize: theme.typography.body2.fontSize,
			whiteSpace: "nowrap"
		}
	},
	// The shared theme paints every disabled control in palette.action.disabled,
	// which it sets to white so disabled buttons read white-on-light-red. MUI's
	// Radio takes its disabled colour from that same token, so on the white
	// form a locked radio vanished, checked or not, and the saved choice with
	// it. Draw it in the disabled text colour instead: the grey of the option
	// label beside it and of a locked text field's value. Same-specificity
	// override, which wins because makeStyles sheets follow MUI's own.
	radioFieldRadio: {
		padding: 4,
		"&.Mui-disabled": {
			color: theme.palette.text.disabled
		}
	},
	iconAdornment: {
		width: "25px",
		height: "25px"
	}
}));

export default configurationStyles;
